import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class PlatformService {
  constructor(public platform: Platform) {}

  isMobile(): boolean {
    return this.isIOS() || this.isAndroid();
  }

  isDesktop(): boolean {
    const desktop = this.platform.is('desktop');
    console.log('======> Desktop: ' + desktop);
    return desktop;
  }

  isIOS(): boolean {
    const ios = this.platform.is('ios');
    console.log('======> IOS: ' + ios);
    return ios;
  }

  isAndroid(): boolean {
    const android = this.platform.is('android');
    console.log('======> Android: ' + android);
    return android;
  }
}
